import { render, staticRenderFns } from "./FullBody.vue?vue&type=template&id=c0e35120&scoped=true&"
import script from "./FullBody.vue?vue&type=script&lang=js&"
export * from "./FullBody.vue?vue&type=script&lang=js&"
import style0 from "./FullBody.vue?vue&type=style&index=0&id=c0e35120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e35120",
  null
  
)

export default component.exports